import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Skeleton from '@pedidosya/web-fenix/atoms/Skeleton';

const Container = styled.div`
  height: 136px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 26px 16px;
  background-color: ${({ theme }) => theme.colors.french_gray_2};
`;

const Search = styled.div`
  height: 24px;
  width: 350px;
  border-radius: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(10)};
  margin: ${({ theme }) => theme.spacing(0, 0, 0, 10)};
`;

const Name = styled.div`
  margin: ${({ theme }) => theme.spacing(0, 0, 8, 10)};
  div {
    border-radius: 12px;
  }
`;

const InputShimmer = styled.div`
  div {
    border-radius: 12px;
  }
`;

const SecondHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  padding: ${({ theme }) => theme.spacing(12, 20)};
  div {
    margin-bottom: ${({ theme }) => theme.spacing(5)};
    border-radius: 12px;
  }
`;

const HeaderShimmer = ({ isPickup }) => (
  <>
    <Container>
      <Name>
        <Skeleton height="8" width="250" shape="square" />
      </Name>
      <Search>
        <Skeleton height="8" width="24" shape="circle" />
        <InputShimmer>
          <Skeleton height="8" width="200" shape="square" />
        </InputShimmer>
      </Search>
    </Container>
    {!isPickup && (
      <SecondHeader>
        <Skeleton height="12" width="160" shape="square" />
        <Skeleton height="12" width="160" shape="square" />
        <Skeleton height="12" width="100" shape="square" />
      </SecondHeader>
    )}
  </>
);

HeaderShimmer.propTypes = {
  isPickup: PropTypes.bool,
};

HeaderShimmer.defaultProps = {
  isPickup: false,
};

export default memo(HeaderShimmer);
